export let CONDUCTOR = {url:"conductores", name:"conductor", label:"Conductor"};
export let UNIDAD = {url:"unidades",name:"Unidad", label:"Unidad"};
export let EQUIPO = {url:"equipos",name:"equipo", label:"Equipo"};
export let TIPO_UNIDAD = {url:"tipos-unidad",name:"tipo_unidad", label:"Tipo de unidad"};
export let VIAJE = {url:"transportistas/me/viajes",name:"viaje", label:"Viaje"};
export let PAGO = {url:"pagos-transportista",name:"pago", label:"Pago"};
export let TRANSPORTISTA = {url:"transportistas/me",name:"transportista", label:"Transportista"};
export let USUARIO = {url:"transportistas/me/usuarios",name:"usuario", label:"Usuario"};
export let SOLICITUD = {url:"solicitudes",name:"solicitud", label:"Solicitud"};
export const MERCANCIA = {url:"tipos-mercancias",name:"mercancia", label:"Mercancia"};
export let SEGURO = {url:"transportistas/me/seguros",name:"seguro", label:"Seguro"};
export let CLIENTE = {url:"transportistas/me",name:"transportista", label:"Transportista"};
